module.exports = __webpack_public_path__ + "media/images/gallery/constellations/coma_berenices/com_names-1a9467d5379bd79722db58fd53dd67a6.gif";